import React from "react";
import { useLang } from "@/lib/i18n";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="mt-20 border-t border-slate-200 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <span className="font-extrabold tracking-tight text-slate-900">{t("brand")}</span>
        <p className="text-sm text-slate-500">{t("footer_rights")}</p>
        <p className="text-sm text-slate-400">© {new Date().getFullYear()} Tagdada</p>
      </div>
    </footer>
  );
};
